import script from "./PortalPromotionDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalPromotionDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./PortalPromotionDetailPage.vue?vue&type=style&index=0&id=73bba45c&lang=scss"
import "./PortalPromotionDetailPage.vue?vue&type=style&index=1&id=73bba45c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73bba45c"]])

export default __exports__